import React from 'react';
import { ReactDOM } from 'react';

function SuporteTi() {

    return (
        <div>
        </div>
    );

}

export function SuporteTiInit() {

    const SuporteTi = document.getElementById('divRender')
    SuporteTi.innerHTML = `<html>
    <head>
    <style>
    .style1 {font-family: Arial, Helvetica, sans-serif}
    .style2 {font-family: Arial, Helvetica, sans-serif; font-weight: bold; }
    </style>
    <title>Colaborador Polishop</title>
    <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
    <meta name="robots" content="noindex, nofollow" />
    </head>
    <body bgcolor="#FFFFFF" leftmargin="0" topmargin="0" marginwidth="0" marginheight="0">
    <br>
    <table width="80%" align="center">
    <tbody>
        <tr>
          <td colspan="3" width="100%"><div class="style1" id="NeoassistCentral"></div></td>
        </tr>
      </tbody>
    </table>`}

export function SuporteTiInit2() {

    let NeoAssistTag = {};

    NeoAssistTag.querystring = true;
    NeoAssistTag.pageid = '';   
    NeoAssistTag.clientdomain = 'polishopti.neoassist.com';

    window.NeoAssistTag = NeoAssistTag

    var na = document.createElement('script');
    na.type = 'text/javascript';
    na.async = true;
    na.src = 'https://cdn.atendimen.to/n.js?ntag=0&d=polishopti.neoassist.com&p=https%3A%2F%2Fcolaborador.polishop.com%2Fcolaborador-ti.html'; 
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(na, s);
}

export default SuporteTi;
